import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import { getAllClientes, getClienteModulo, getClientes } from "../queries/getClientes";

export function useGetCliente(ClienteId: number) {
  const resultQuery = useQuery(
    [URLS.CLIENTE_ID_API.replace("id", ClienteId.toString())],
    () => getClienteModulo(ClienteId)
  );

  return resultQuery;
}

export default function useGetClientes(search?: string, page: number = 1) {
  const resultQuery = useQuery(
    [`${URLS.CLIENTES_API}`, {
      params: { search, page }
    }],
    () => getClientes(search, page)
  );

  return resultQuery;
}

export function useGetAllClientes(search? : string) {

  const resultQuery = useQuery(
    search ? [`${URLS.CLIENTES_API}?search=${search}`] : [URLS.CLIENTES_API]
    , () => getAllClientes(search));

  return resultQuery;
}
